<wiz-vgroup class="tile-shadow" width="100%" height="100%" gap="0">
  <!-- Entête -->
  <!-- Première partie (titre + bontons d'action) -->
  <wiz-vgroup
    width="100%"
    gap="0"
    class="tile-header"
  >
    <wiz-hgroup  width="100%" height="35px" [verticalAlign]="'center'" gap="0" [horizontalAlign]="'space-between'">
      <div [ngStyle]="{'width': titleWidth}"> <!-- [ngStyle]="{'width': titleWidth}" -->
        <ng-content select="[target=title]"></ng-content>
      </div>
      <div heigth="100%">
        <ng-content select="[target=actionButtons]"></ng-content>
      </div>
    </wiz-hgroup>

    <!-- Seconde partie (titre complémentaire) -->
    <wiz-hgroup
      width="100%" height="25px" [verticalAlign]="'center'"  [horizontalAlign]="'space-between'" *ngIf="showComplementaryTitle">
      <div width="100%" class="tile-subtitle">
        <ng-content select="[target=complementaryTitle]"></ng-content>
      </div>
    </wiz-hgroup>
  </wiz-vgroup>



  <!-- Corps -->
  <wiz-hgroup width="100%" height="100%" [verticalAlign]="'center'" [horizontalAlign]="'space-between'">
    <div width="100%" height="100%" class="tile-body" style="padding: 5px;">
      <ng-content select="[target=body]"></ng-content>
    </div>
  </wiz-hgroup>

  <!-- Pied -->
  <wiz-hgroup width="100%" height="16px" class="tile-footer" [verticalAlign]="'center'" gap="0">
    <wiz-label
      [wizLabel]="footerText"
      [ngClass]="{'wiz-not-updated': !updated}"
      [ngStyle]="{'width': footerTextWidth}"
      [wizTextBehavior]="'truncate'"
    >
    </wiz-label>
    <wiz-icon *ngIf="deprecated">deprecated</wiz-icon>
    <wiz-icon *ngIf="deleted">deleted-state </wiz-icon>
  </wiz-hgroup>
</wiz-vgroup>
